import { render } from "./UnderstandingOptions.vue?vue&type=template&id=c585190e&scoped=true"
import script from "./UnderstandingOptions.vue?vue&type=script&lang=js"
export * from "./UnderstandingOptions.vue?vue&type=script&lang=js"

import "./UnderstandingOptions.vue?vue&type=style&index=0&id=c585190e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c585190e"]])

export default __exports__